import styled from 'styled-components';

import { media } from 'styles/utils';

export const HeaderContainer = styled.div`
  width: 100%;
  height: 70px;
  position: relative;
  padding: 14px 17px;
  background-color: #fff;

  ${media.desktop`
    height: 76px;
  `}
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: calc(50% - 21px);
  left: calc(50% - 50px);
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 17px;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 17px;
`;

export const Bottom = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
`;
